var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2168,
    cy: 50,
    r: 50,
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9032 25H34.1579C31.0304 25 28.5 27.25 28.5 30L28.4716 70C28.4716 72.75 31.002 75 34.1294 75H68.2758C71.4033 75 73.9621 72.75 73.9621 70V40L56.9032 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1465 52.5414C54.1691 52.5414 57.4301 50.5583 57.4301 48.1122C57.4301 45.666 54.1691 43.683 50.1465 43.683C46.1239 43.683 42.8629 45.666 42.8629 48.1122C42.8629 50.5583 46.1239 52.5414 50.1465 52.5414Z",
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8557 52.7663V67.0381C42.919 69.4531 46.153 71.397 50.1358 71.397C54.1185 71.397 57.3526 69.4531 57.4158 67.0381V64.2892C57.4158 64.233 57.4158 64.1803 57.4158 64.124V52.7663C55.7074 54.2216 53.1026 55.1355 50.1287 55.1355C47.1548 55.1355 44.5641 54.2216 42.8557 52.7663Z",
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.312 43.4614C46.3346 43.4614 49.5955 41.4784 49.5955 39.0322C49.5955 36.586 46.3346 34.603 42.312 34.603C38.2893 34.603 35.0284 36.586 35.0284 39.0322C35.0284 41.4784 38.2893 43.4614 42.312 43.4614Z",
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1332 43.4614C62.1559 43.4614 65.4168 41.4784 65.4168 39.0322C65.4168 36.586 62.1559 34.603 58.1332 34.603C54.1106 34.603 50.8497 36.586 50.8497 39.0322C50.8497 41.4784 54.1106 43.4614 58.1332 43.4614Z",
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0239 47.0926V57.9617C35.0801 60.2009 36.6936 62.1484 40.2721 62.405V47.9925C40.2748 47.8738 40.2913 47.7559 40.3213 47.641C40.4031 47.1304 40.5732 46.6379 40.824 46.1857C37.9802 46.1259 36.6655 45.11 35.0168 43.7039L35.0239 47.0926Z",
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4734 46.0522C59.7242 46.502 59.8943 46.9921 59.9761 47.5005C60.0057 47.6155 60.0222 47.7334 60.0253 47.852V62.2856C63.6776 62.0712 65.3544 60.2187 65.4142 57.9478V55.1848C65.4142 55.1286 65.4142 55.0759 65.4142 55.0196V43.683C63.7514 45.1137 62.3805 46.0101 59.4734 46.0522Z",
    fill: "",
    className: "fillWithPrimaryColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.83619f64988d3256dff5d1153c9d3e10.svg";
export { ForwardRef as ReactComponent };